import * as React from 'react';
import { CaptionElementProps } from 'react-day-picker';

import { translations } from '../../translations';
import { CalendarCaptionHeading } from './styled';

export const CalendarCaption: React.FC<CaptionElementProps> = ({
  date,
}) => (
  <CalendarCaptionHeading as="h2">
    {translations.months[date.getMonth()]}
  </CalendarCaptionHeading>
);
